// extracted by mini-css-extract-plugin
export default {"div":"JokerList_div__BuMF+","joker":"JokerList_joker__m7FSe"};